import {CONTENT_TYPE_TEXT, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'AJOUT_DOC',
  title: 'Wie kann ich ein zusätzliches Dokument hinzufügen?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf der Registerkarte "Dokumente"'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie dann auf "Dokument hinzufügen".'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Wählen Sie das Dokument Ihrer Wahl aus oder suchen Sie danach'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '4.',
    value: 'Klicken Sie dann auf "Bestätigen".'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ihr Dokument wird direkt zu Ihrem Ordner hinzugefügt. Sie müssen es nur noch hochladen.'
  }]
};
